<template>
    <div class="usdt_wrap">
        <div class="red_top_bg">
            <div class="back_left" @click="$router.push('/user')"></div>
            <div class="big_tit">{{data.payment.name}}</div>
        </div>
        <div class="code_box">
			<div class="money">{{$t('utils.moneyMark')}}{{money}}
				<span>{{actualAmount}}</span>
			</div>
			<div v-if="data.payment.type==1">{{$t('invest_qrcode.scanQRcode')}}</div>
            <div class="qrcode_img">
				<img class="qrcode" :src="imgUrl(data.payment.qrcode)" alt="" />
			</div>
			<div class="wallet" v-if="data.payment.type==1">{{$t('invest_qrcode.walletAddress')}}</div>
			<div class="walletAddress" v-if="data.payment.type==1">{{data.payment.address}}</div>
        </div>
		<div class="button_box" v-if="data.payment.type==1">
			<div class="copy_link" @click="copyAddress" v-clipboard="() => data.payment.address" v-clipboard:success="copy">{{$t('invest_qrcode.copyWalletAddress')}}</div>
		</div>
		<div class="voucher_box">
			<div class="voucher_title">{{$t('invest_qrcode.voucherTitle')}}</div>
			<div class="voucher_upload_area">
				<van-uploader
					v-model="fileList"
					:max-count="1"
					:max-size="5 * 1024 * 1024"
					:before-read="beforeRead"
					:after-read="afterRead"
					@oversize="onOversize"
					@delete="onDelete"
				>
					<div class="voucher_placeholder" v-if="!fileList.length">
						<span class="voucher_plus">+</span>
					</div>
				</van-uploader>
			</div>
			<div class="voucher_hint">{{$t('invest_qrcode.voucherHint')}}</div>
		</div>
        <div class="basic_btn" @click="submitBtn">{{$t('utils.submit')}}</div>
    </div>
</template>

<script>
	import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	import { Uploader, Toast } from 'vant';
	import { isAllowedVoucherFile, normalizeVoucherFile, uploadVoucherFile } from '../../utils/voucherUpload';
	Vue.use(Clipboard).use(Uploader);
    export default {
        name: "invest_qrcode",
        data() {
            return {
                data: {},
                money: 0,
				actualAmount:'',
				voucher: '',
				fileList: [],
				uploading: false,
				submitting: false,
            };
        },
        created() {
            this.$parent.footer('user', false);
        },
        mounted() {
            this.money = this.$route.query.money;
            if (!this.money || !this.$route.query.id) {
                this.$router.replace('/invest');
                return;
            }
            this.start();
        },
        methods: {
			imgUrl(url) {
				if (!url) return '';
				if (/^https?:\/\//.test(url)) return url;
				if (/^\/\//.test(url)) return window.location.protocol + url;
				if (url.charAt(0) === '/') return Api.commonUrl + url;
				return url;
			},
            start() {
            	Fetch('/user/recharge_type', {
            		money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : ""
            	}).then((r) => {
            		this.data = r.data;
					this.changeAmount();
            	});
            },
            submitBtn(){
				if (this.uploading) {
					this.$toast({
						className: "toastName",
						message: this.$t('invest_qrcode.voucherUploading'),
					});
					return;
				}
				if (!this.voucher) {
					this.$toast({
						className: "toastName",
						message: this.$t('invest_qrcode.voucherEmpty'),
					});
					return;
				}
				if (this.submitting) return;
				this.submitting = true;
				Fetch("/user/recharge_apply", {
					id: this.data.orderId,
					voucher: this.voucher,
				}).then((r) => {
					this.submitting = false;
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				}).catch(() => {
					this.submitting = false;
				});
			},
			onOversize() {
				this.$toast(this.$t('invest_qrcode.voucherOversize'));
			},
			beforeRead(file) {
				const f = (file && file.file) ? file.file : (Array.isArray(file) ? file[0] : file);
				if (!isAllowedVoucherFile(f)) {
					this.$toast(this.$t('invest_qrcode.voucherType'));
					return false;
				}
				return true;
			},
			async afterRead(item) {
				const raw = item.file || (item instanceof File ? item : null);
				if (!raw) return;
				this.uploading = true;
				this.voucher = '';
				try {
					const file = await normalizeVoucherFile(raw);
					const url = await uploadVoucherFile(file, {
						commonUrl: Api.commonUrl,
						token: localStorage.getItem('token'),
						language: this.$i18n.locale || localStorage.getItem('lang') || 'zh_cn',
					});
					if (!url) {
						throw new Error('empty url');
					}
					this.voucher = url;
				} catch (err) {
					this.$toast((err && err.message) || this.$t('invest_qrcode.voucherUploadFail'));
					this.fileList = [];
					this.voucher = '';
				} finally {
					this.uploading = false;
				}
			},
			onDelete() {
				this.voucher = '';
			},
			copyAddress() {
			    this.mask_show = true;
			    var that = this;
			    var local = window.location.origin;
			    var url = local + this.data.down_image;
			},
			copy() {
				this.$toast({
					className:"toastName",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment.mark+")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num)+")";
				}
			}
        }
    };
</script>

<style lang="less" scoped>
	.usdt_wrap{
		background: url(../images/login/login_bg.png) no-repeat center top;
		background-size: contain;
		width: 100%;
		min-height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
		padding-bottom: 30px;
	}
	.red_top_bg{
		background: none;
	}
	.button_box{
		width: 90%;
		margin-left: 5%;
		height: 60px;
		background: #ebedf0;
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: -10px;
		display: flex;
		text-align: center;
		.copy_link{
			width: 100%;
			line-height: 60px;
		}
	}
    .code_box {
        width: 90%;
		margin-left: 5%;
        padding: 30px 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 6px;
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
		.money{
			color: #000;
			font-size: 26px;
			span{
				font-size: 14px;
				color: #999;
			}
		}
		.wallet{
			margin-top: 10px;
		}
		.walletAddress{
			text-align: center;
			color: #000;
			width: 80%;
		}
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 15px;
		}
        .qrcode_img{
        	width: 200px;
        	height: 200px;
        	margin: 0 auto;
			text-align: center;
        	background: linear-gradient(to left, #999, #999) left top no-repeat, 
        				linear-gradient(to bottom, #999, #999) left top no-repeat, 
        				linear-gradient(to left, #999, #999) right top no-repeat,
        				linear-gradient(to bottom, #999, #999) right top no-repeat, 
        				linear-gradient(to left, #999, #999) left bottom no-repeat,
        				linear-gradient(to bottom, #999, #999) left bottom no-repeat,
        				linear-gradient(to left, #999, #999) right bottom no-repeat,
        				linear-gradient(to left, #999, #999) right bottom no-repeat;
        	background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
        	span{
        		line-height: 220px;
        	}
        	img{
        		width: 190px;
        		height: 190px;
        		margin-top: 5px;
        	}
        }

        p {
            font-size: 15px;
            line-height: 21px;
            color: #000;
            font-weight: bold;
            margin-top: 13px;
        }
		.address_left{
			width: 90%;
			text-align: left;
		}
    }

    .warming {
        margin-top: 17px;
        padding: 0 14px;

        .tit {
            font-size: 14px;
            color: rgba(0,0,0,.8);
            line-height: 20px;
            font-weight: bold;
        }

        .content {
            font-size: 12px;
            color: rgba(0,0,0,.6);
            line-height: 17px;
            margin-top: 9px;
        }
    }

    .basic_btn {
        margin: 30px auto 0 auto;
    }

	.voucher_box {
		width: 90%;
		margin: 16px auto 0;
		padding: 20px 16px 16px;
		background: #fff;
		border-radius: 6px;
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);

		.voucher_title {
			font-size: 16px;
			color: #333;
			font-weight: bold;
			text-align: center;
			margin-bottom: 16px;
		}

		.voucher_hint {
			font-size: 12px;
			color: #999;
			text-align: center;
			margin-top: 12px;
			line-height: 18px;
		}

		.voucher_upload_area {
			width: 100%;

			.voucher_placeholder {
				width: 100%;
				height: 160px;
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				background: #fafafa;
				display: flex;
				align-items: center;
				justify-content: center;

				.voucher_plus {
					font-size: 40px;
					color: #ccc;
					line-height: 1;
					font-weight: 300;
				}
			}

			/deep/ .van-uploader {
				width: 100%;
			}

			/deep/ .van-uploader__wrapper {
				justify-content: center;
				width: 100%;
			}

			/deep/ .van-uploader__input-wrapper {
				width: 100%;
			}

			/deep/ .van-uploader__upload {
				width: 100%;
				height: 160px;
				margin: 0;
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				background: #fafafa;
			}

			/deep/ .van-uploader__upload-icon {
				font-size: 40px;
				color: #ccc;
			}

			/deep/ .van-uploader__preview {
				width: 100%;
				margin: 0;
			}

			/deep/ .van-uploader__preview-image {
				width: 100%;
				height: 160px;
				object-fit: contain;
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				background: #fafafa;
			}

			/deep/ .van-uploader__preview-delete {
				width: 22px;
				height: 22px;
				border-radius: 50%;
				background: rgba(0, 0, 0, 0.45);
				top: 8px;
				right: 8px;
			}
		}
	}
</style>
